import { render, staticRenderFns } from "./dependency-calculation-config.vue?vue&type=template&id=4badac85&"
import script from "./dependency-calculation-config.vue?vue&type=script&lang=js&"
export * from "./dependency-calculation-config.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports